module.exports = __webpack_public_path__ + "img/ranking3.99950f4b.png";